import * as React from "react";
import { clearedDreamFilters } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Helpers/clearedDreamFilters";
import Dreams from "source/app/presentation/MainPanel/Dreams/Dreams";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render from "source/app/presentation/Shared/Render";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { NavigateToDreamsRoute } from "../../Routing/DreamsRouting";

export function ShowFiguringOut({ dreams }: { dreams: Dreams }) {
    const figureOutText = `figure out`;

    const figuringOutFilters = {
        ...clearedDreamFilters,
        searchText: figureOutText,
    };

    const numberOfDreamsToFigureOut = dreams
        ? dreams.state.dreamsdata.filter((dream) =>
              dream.name.toLowerCase().includes(figureOutText)
          ).length
        : 0;

    return (
        <Render
            id="showDreamToFigureOutButton"
            when={numberOfDreamsToFigureOut > 0}
        >
            <span id="showDreamsToFigureOut">
                <IconWithText
                    iconSuffix={EGlyphicon.adjust}
                    whenClicked={() => {
                        NavigateToDreamsRoute(`FiguringOut`);
                        dreams.setState(figuringOutFilters);
                    }}
                    displayAsBlock={false}
                >
                    {`${numberOfDreamsToFigureOut} to figure out`}
                </IconWithText>
            </span>
        </Render>
    );
}
